exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__HarvestAndPlantingLegend__legendContainer__P0lNx {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports
exports.locals = {
	"legendContainer": "dmb-web__HarvestAndPlantingLegend__legendContainer__P0lNx"
};